/**
 * Consolidated API Routes Configuration
 * This file contains all application routes from the constant/route modules
 */

// Authentication Routes
export const AUTH_ROUTES = {
  index: {
    path: '/*',
    to: '/',
  },
  login: {
    path: 'login',
    to: '/login',
  },
  forgotPassword: {
    path: 'forgot-password',
    to: '/forgot-password',
  },
  resetPassword: {
    path: 'reset-password',
    to: '/reset-password',
  },
}

// Admin Routes
export const ADMIN_ROUTES = {
  index: {
    path: 'admin/*',
    to: '/admin/interface',
  },
  interface: {
    path: 'admin/interface',
    to: '/interface',
  },
  organizations: {
    path: 'admin/*',
    to: '/admin/organizations',
  },
  map_overlay: {
    path: 'admin/*',
    to: '/admin/interface/map_overlay_site',
  },
}

// Configuration Routes
export const CONFIG_ROUTES = {
  index: {
    path: 'config/*',
    to: '/config/sites-and-locations',
  },
  sitesAndLocations: {
    path: '/sites-and-locations',
    to: '/config/sites-and-locations',
  },
  areasAndZones: {
    path: 'station-config/areas-and-zones',
    to: '/config/station-config/areas-and-zones',
  },
  controllers: {
    path: 'station-config/controllers',
    to: '/config/station-config/controllers',
  },
  pipes: {
    path: '/pipes',
    to: '/config/pipes',
  },
  pumps: {
    path: '/pumps',
    to: '/config/pumps',
  },
  plants: {
    path: '/plants',
    to: '/config/plants',
  },
  alert: {
    path: '/alert',
    to: '/config/alert',
  },
  soil: {
    path: '/soil',
    to: '/config/soil',
  },
  etReference: {
    path: '/etReference',
    to: '/config/etReference',
  },
  emitter: {
    path: '/emitter',
    to: '/config/emitter',
  },
  sensors: {
    path: '/sensors',
    to: '/config/sensors',
  },
  etz: {
    path: 'sensors/etz',
    to: '/config/sensors/etz',
  },
  stations: {
    path: 'station-config/stations',
    to: '/config/station-config/stations',
  },
  dataConfig: {
    path: '/dataConfiguration',
    to: '/config/dataConfiguration',
  },
  hydraulic: {
    path: '/hydraulic',
    to: '/config/hydraulic',
  },
  hydraulicRule: {
    path: '/hydraulic/:pipeId',
    to: '/config/hydraulic',
  },
}

// Configuration Setup Routes
export const CONFIG_SETUP_ROUTES = {
  index: {
    path: 'config-setup/*',
    to: '/config-setup',
  },
  setupFirstUser: {
    path: 'setup_first',
    to: '/config-setup/setup_first',
  },
  setupFirst: {
    path: 'setup_first/:id',
    to: (id: string) => `/config-setup/setup_first/${id}`,
  },
  discovery: {
    path: 'discovery/:id',
    to: (id: string) => `/config-setup/discovery/${id}`,
  },
  setupSecond: {
    path: 'setup_second/:id',
    to: (id: string) => `/config-setup/setup_second/${id}`,
  },
  setupPlant: {
    path: 'setup-plant',
    to: '/config-setup/setup-plant',
  },
  setupSoil: {
    path: 'setup-soil',
    to: '/config-setup/setup-soil',
  },
  setupEmitter: {
    path: 'setup-emitter',
    to: '/config-setup/setup-emitter',
  },
  setupEtReference: {
    path: 'setup-etReference',
    to: '/config-setup/setup-etReference',
  },
  setupEtZone: {
    path: 'setup-etZone',
    to: '/config-setup/setup-etZone',
  },
  setupAreas: {
    path: 'setup-Areas',
    to: '/config-setup/setup-Areas',
  },
  sites: {
    path: 'sites',
    to: '/config-setup/sites',
  },
  sitesCommon: {
    path: 'common-sites',
    to: '/config-setup/common-sites',
  },
  dataSites: {
    path: 'data-sites',
    to: '/config-setup/data-sites',
  },
  pipes: {
    path: 'pipes',
    to: '/config-setup/pipes',
  },
  pipesCommon: {
    path: 'common-pipes',
    to: '/config-setup/common-pipes',
  },
  dataPipes: {
    path: 'data-pipes',
    to: '/config-setup/data-pipes',
  },
  pump: {
    path: 'pump',
    to: '/config-setup/pump',
  },
  pumpCommon: {
    path: 'common-pump',
    to: '/config-setup/common-pump',
  },
  dataPump: {
    path: 'data-pump',
    to: '/config-setup/data-pump',
  },
  plant: {
    path: 'plant',
    to: '/config-setup/plant',
  },
  plantCommon: {
    path: 'common-plant',
    to: '/config-setup/common-plant',
  },
  dataPlant: {
    path: 'data-plant',
    to: '/config-setup/data-plant',
  },
  soil: {
    path: 'soil',
    to: '/config-setup/soil',
  },
  soilCommon: {
    path: 'common-soil',
    to: '/config-setup/common-soil',
  },
  dataSoil: {
    path: 'data-soil',
    to: '/config-setup/data-soil',
  },
  historical: {
    path: 'historical',
    to: '/config-setup/historical',
  },
  historicalCommon: {
    path: 'common-historical',
    to: '/config-setup/common-historical',
  },
  dataHistorical: {
    path: 'data-historical',
    to: '/config-setup/data-historical',
  },
  emitter: {
    path: 'emitter',
    to: '/config-setup/emitter',
  },
  emitterCommon: {
    path: 'common-emitter',
    to: '/config-setup/common-emitter',
  },
  dataEmitter: {
    path: 'data-emitter',
    to: '/config-setup/data-emitter',
  },
  sensor: {
    path: 'sensor',
    to: '/config-setup/sensor',
  },
  sensorCommon: {
    path: 'common-sensor',
    to: '/config-setup/common-sensor',
  },
  dataSensor: {
    path: 'data-sensor',
    to: '/config-setup/data-sensor',
  },
  et: {
    path: 'et',
    to: '/config-setup/et',
  },
  etCommon: {
    path: 'common-et',
    to: '/config-setup/common-sensor',
  },
  dataET: {
    path: 'data-et',
    to: '/config-setup/data-et',
  },
  setupThird: {
    path: 'setup_third',
    to: '/config-setup/setup_third',
  },
  station: {
    path: 'station',
    to: '/config-setup/station',
  },
  stationCommon: {
    path: 'common-station',
    to: '/config-setup/common-station',
  },
  dataStation: {
    path: 'data-station',
    to: '/config-setup/data-station',
  },
  setupFour: {
    path: 'setup_four',
    to: '/config-setup/setup_four',
  },
  stationAssignment: {
    path: 'station-assignment',
    to: '/config-setup/station-assignment',
  },
  stationAssignmentCommon: {
    path: 'common-station_assignment',
    to: '/config-setup/common-station_assignment',
  },
  dataStationAssignment: {
    path: 'data-station_assignment',
    to: '/config-setup/data-station_assignment',
  },
  setupFinish: {
    path: 'setup_finish',
    to: '/config-setup/setup_finish',
  },
}

// Operations Routes
export const OPERATIONS_ROUTES = {
  index: {
    path: 'dashboard/*',
    to: '/dashboard',
  },
  manualOperations: {
    path: 'manual-station',
    to: '/dashboard/manual-station',
  },
  simulation: {
    path: 'simulation',
    to: '/dashboard/simulation',
  },
  flowHistory: {
    path: 'flowHistory',
    to: '/dashboard/flowHistory',
  },
  manualStation: {
    path: 'manual-station',
    to: '/dashboard/manual-station',
  },
  manualRun: {
    path: 'manual-run',
    to: '/dashboard/manual-run',
  },
  manualPrograms: {
    path: 'manual-programs',
    to: '/dashboard/manual-programs',
  },
  stations: {
    path: 'stations',
    to: '/dashboard/stations',
  },
  programs: {
    path: 'programs',
    to: '/dashboard/programs',
  },
  irrigationOverview: {
    path: 'irrigation-overview',
    to: '/dashboard/irrigation-overview',
  },
  programSchedule: {
    path: 'programSchedule',
    to: '/dashboard/programSchedule',
  },
  weather: {
    path: 'weather',
    to: '/dashboard/weather',
  },
  sensors: {
    path: 'sensors',
    to: '/dashboard/sensors',
  },
  flowSensors: {
    path: 'flowSensors',
    to: '/dashboard/flowSensors',
  },
  mapview: {
    path: 'mapview',
    to: '/dashboard/mapview',
  },
  fertigationDashboard: {
    path: 'fertigation-dashboard',
    to: '/dashboard/fertigation-dashboard',
  },
  filtration: {
    path: 'filtration',
    to: '/dashboard/filtration',
  },
  fertigation: {
    path: 'fertigation',
    to: '/dashboard/fertigation',
  },
  etAdjust: {
    path: 'et-adjust',
    to: '/dashboard/et-adjust',
  },
  dryRun: {
    path: 'dry-run',
    to: '/dashboard/dry-run',
  },
  mad: {
    path: 'mad',
    to: '/dashboard/mad',
  },
  alerts: {
    path: 'alerts',
    to: '/dashboard/alerts',
  },
  waterBudget: {
    path: 'water-budget',
    to: '/dashboard/water-budget',
  },
  runTime: {
    path: 'run-time',
    to: '/dashboard/run-time',
  },
  learnFlow: {
    path: 'learn-flow',
    to: '/dashboard/learn-flow',
  },
  diagnosis: {
    path: 'diagnosis',
    to: '/dashboard/diagnosis',
  },
  activities: {
    path: 'other/activities',
    to: '/dashboard/other/activities',
  },
  reports: {
    path: 'other/reports',
    to: '/dashboard/other/reports',
  },
  projectedWaterUsage: {
    path: '/other/projectedWaterUsage',
    to: '/dashboard/other/projectedWaterUsage',
  },
  waterUsage: {
    path: 'other/waterUsage',
    to: '/dashboard/other/waterUsage',
  },
  flowLog: {
    path: 'other/flowLog',
    to: '/dashboard/other/flowLog',
  },
  flowLogReport: {
    path: 'other/flowLogReport',
    to: '/dashboard/other/flowLogReport',
  },
  monthlyReportCard: {
    path: 'other/monthlyReportCard',
    to: '/dashboard/other/monthlyReportCard',
  },
  stationRunTime: {
    path: 'other/stationRunTime',
    to: '/dashboard/other/stationRunTime',
  },
  userManagement: {
    path: 'user-management',
    to: '/dashboard/user-management',
  },
  chartZeus: {
    path: 'chart-zeus',
    to: '/dashboard/chart-zeus',
  },
  diagnostics: {
    path: 'diagnostics',
    to: '/dashboard/diagnostics',
  },
}

// Changelog Routes
export const CHANGELOG_ROUTES = {
  index: {
    path: 'changelog',
    to: '/dashboard/changelog',
  },
}

// Consolidated Routes Object
export const ALL_ROUTES = {
  AUTH: AUTH_ROUTES,
  ADMIN: ADMIN_ROUTES,
  CONFIG: CONFIG_ROUTES,
  CONFIG_SETUP: CONFIG_SETUP_ROUTES,
  OPERATIONS: OPERATIONS_ROUTES,
  CHANGELOG: CHANGELOG_ROUTES,
}

// Route Helper Functions
export const getRoute = (category: keyof typeof ALL_ROUTES, route: string) => {
  return ALL_ROUTES[category][
    route as keyof (typeof ALL_ROUTES)[typeof category]
  ]
}

export const getAllRoutes = () => ALL_ROUTES

// Route Path Extractors
export const getAllPaths = () => {
  const allPaths: string[] = []

  Object.values(ALL_ROUTES).forEach((routeCategory) => {
    Object.values(routeCategory).forEach((route) => {
      if (typeof route.to === 'string') {
        allPaths.push(route.to)
      }
    })
  })

  return allPaths
}

export const getPathsByCategory = (category: keyof typeof ALL_ROUTES) => {
  const paths: string[] = []

  Object.values(ALL_ROUTES[category]).forEach((route) => {
    if (typeof route.to === 'string') {
      paths.push(route.to)
    }
  })

  return paths
}
